import cx from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React, { memo } from 'react';
import { Processing } from '@wg/wows-react-uikit';

import { disableWaapi } from '~/helpers/animate';

import styles from './AnimatedFetchingComponent.module.scss';

const animation = {
  animate: { opacity: 1, transition: { delay: 0.2 } },
  exit: { opacity: 0 },
  initial: { opacity: 0 },
  transition: { duration: 0.4 },
  onUpdate: disableWaapi,
};

const animationLoader = {
  ...animation,
  transition: { duration: 0.2 },
};

interface AnimatedFetchingComponentPropsProps {
  isFetching: boolean;
  children?: React.ReactNode;
  className?: string;
  isContain?: boolean;
  isGlobal?: boolean;
  label?: string;
}

const AnimatedFetchingComponent: React.FC<AnimatedFetchingComponentPropsProps> = ({
  children,
  className,
  isContain = false,
  isFetching = false,
  isGlobal = false,
  label,
}) => {
  return (
    <AnimatePresence>
      {isFetching ? (
        <motion.div
          className={cx(styles.loader, {
            [styles.contain]: isContain,
            [styles.global]: isGlobal,
            [styles.local]: !isGlobal,
          })}
          {...animationLoader}
          key={'loader'}
        >
          <Processing className={styles.processing} isFetching={true} label={label} />
        </motion.div>
      ) : (
        <motion.div className={className} {...animation} key={'content'}>
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default memo(AnimatedFetchingComponent);
